import { intervalToDuration } from 'date-fns';

export type GenerateDurationFromStringsOptions = {
  start?: string;
  end?: string;
};

export const generateDurationFromStrings = ({
  start,
  end,
}: GenerateDurationFromStringsOptions): string => {
  const startTime = start ? new Date(start).getTime() : new Date().getTime();
  const endTime = end ? new Date(end).getTime() : new Date().getTime();

  const { hours, minutes, seconds } = intervalToDuration({
    start: startTime,
    end: endTime,
  });

  const HH = hours ? hours.toString().padStart(2, '0') : '00';
  const mm = minutes ? minutes.toString().padStart(2, '0') : '00';
  const ss = seconds ? seconds.toString().padStart(2, '0') : '00';

  return `${HH}:${mm}:${ss}`;
};
